import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import styled from 'styled-components';
import media from '@dbh/media-queries';
import LightweightSection from '@dbh/section';
import '@dbh/styled-helpers';

var _templateObject;// we want to avoid adding complexity to that component, by making
// the margins themeable.
const SearchResultsPageSection=/*#__PURE__*/styled(LightweightSection).withConfig({componentId:"sc-1hpop7u-0"})(["",""],media.md(_templateObject||(_templateObject=_taggedTemplateLiteralLoose(["\n    width: unset;\n    margin: 0 2rem;\n    align-self: center;\n  "]))));SearchResultsPageSection.displayName="SearchResultsPageSection";

export { SearchResultsPageSection as default };
